import React from 'react';

import GroupBadge from '../media/images/smart-solutions-group.png';
import { companies, contact } from '../data/site';

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="shell">
                <div className="footer__top">
                    <a className="footer__brand" href="#top">
                        <img src={GroupBadge} alt="The Smart Solutions Group" width="64" height="64" />
                        <span>
                            <strong>The Smart Solutions Group</strong>
                            <small>LV + HV Electric · Smart Techs · Construction</small>
                        </span>
                    </a>

                    <div className="footer__contact">
                        <a href={contact.phoneHref}>{contact.phone}</a>
                        <a href={contact.addressHref} target="_blank" rel="noopener noreferrer">
                            {contact.address}
                        </a>
                    </div>
                </div>

                <ul className="footer__companies">
                    {companies.map(company => (
                        <li key={company.id} style={{ '--accent': company.accent }}>
                            <a href={company.url} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={company.logo}
                                    alt={company.name}
                                    width="1920"
                                    height="1080"
                                    loading="lazy"
                                    decoding="async"
                                />
                                <span className="footer__companies-cta">
                                    Visit site <span aria-hidden="true">→</span>
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>

                <hr className="rule" />

                <div className="footer__bottom">
                    <p>© {year} The Smart Solutions Group. All rights reserved.</p>
                    <ul className="footer__social">
                        {companies.map(company => (
                            <li key={company.id}>
                                <a href={company.instagram} target="_blank" rel="noopener noreferrer">
                                    {company.short} on Instagram
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </footer>
    );
}
